module.exports = __webpack_public_path__ + "static/media/yesbank.a211fb0b.svg";